export const Consts = {
  HEIGHT_MIN: 30.0,
  HEIGHT_MAX: 220.0,
  HEIGHT_DEFAULT: 160.0,
  WEIGHT_DEFAULT: 60.0,
  WEIGHT_MIN: 5.0,
  WEIGHT_MAX: 300.0,
  HEIGHT: "height",
  WEIGHT: "weight",
  KG: "kg",
  CM: "cm",
  NOT: "not",
  CHAPTER: "chapter",
  BLOCK: "block",
  CATEGORY: "category",
  DAY_TIMES: "dayTimes",
  DAYS: "day(s)",
  TIMES: "times",
  MORNING: "morning",
  NOON: "noon",
  EVENING: "evening",
  NIGHT: "night",
  REGULARLY: "regularly",
  ON_DEMAND: "on_demand",
  INTAKE_TIME_OPTIONS: "intake kind options",
  FREQUENCY_UNIT: "frequencyUnit",
  STRENGTH_UNIT: "strengthUnit",
  DOSAGE: "dosage",
  TIME: "time",
  PRODUCT: "product",
  SUBSTANCE: "substance",
  ATC: "atc",
  START_DATE: "start_date",
  END_DATE: "end_date",
  ABDA: "abda_substance",
  MANUALLY: "manually",
  UPLOAD: "upload",
  PZN: "PZN",
  ATTACHMENT: "attachment",
  DEFAULT_MORNING_INTAKE_TIME: "08:00",
  DEFAULT_NOON_INTAKE_TIME: "13:00",
  DEFAULT_EVENING_INTAKE_TIME: "18:00",
  DEFAULT_NIGHT_INTAKE_TIME: "23:00",
  DEFAULT_DAY_TIME_INTAKES: [
    {
      timeName: "morning",
      intakeTime: "08:00",
      dosage: 0,
      dosageUnit: ""
    },
    {
      timeName: "noon",
      intakeTime: "13:00",
      dosage: 0,
      dosageUnit: ""
    },
    {
      timeName: "evening",
      intakeTime: "18:00",
      dosage: 0,
      dosageUnit: ""
    },
    {
      timeName: "night",
      intakeTime: "23:00",
      dosage: 0,
      dosageUnit: ""
    }
  ],
  DAY_TIME_INDEX_MAP: {
    ["morning"]: 0,
    ["noon"]: 1,
    ["evening"]: 2,
    ["night"]: 3,
  },
  DEFAULT_DAY_TIMES: [
    "08:00",
    "13:00",
    "18:00",
    "23:00",
  ],
  DAY_TIME_NAMES: [
    "morning",
    "noon",
    "evening",
    "night",
  ],
  ALL_GENE_NAMES: ["CYP2C9", "CYP2C19", "CYP2D6", "SLCO1B1", "ABCG2", "CFTR", "COMT", "CYP1A2", "CYP2B6", "CYP2C8", "CYP3A4", "CYP3A5", "DPYD", "HLA-A", "HLA-B", "HLA-B44", "MTHFR", "NAT2", "NUDT15", "TPMT", "UGT1A1", "VKORC1"],
  ANDERS_GENES: ["CYP2C9", "UGT1A1"],
  PATIENT_INITIAL_GENES: ["CYP2C9", "CYP2C19", "CYP2D6", "SLCO1B1"],
  LANGUAGE: "language",
  STUDY_BRANCH: "studyBranch",
  PATIENT: "patient",
  PATIENT_HEADER: "patient_header",
  PATIENTS: "patients",
  USER_ID: "userId",
  PHENO_RISKS: "phenoRisks",
  GENO_RISKS: "genoRisks",
  COMPLETE_RISKS: "completeRisks",
  INTERMEDIATE_METABOLIZER: "Intermediate metabolizer",
  POOR_METABOLIZER: "Poor metabolizer",
  INTERMEDIATE_FUNCTION: "Intermediate function",
  POOR_FUNCTION: "Poor function",
  NORMAL_FUNCTION: "Normal function",
  HETEROZYGOTE_EXPRESSER: "Heterozygote expresser",
  HOMOZYGOTE_EXPRESSER: "Homozygote expresser",
  NOT_CYP2C9_INTERMEDIATE_GENOS: ["*1/*2", "*1/*3", "*2/*5"],
  NOT_CYP2C9_POOR_GENOS: ["*2/*2", "*2/*3", "*3/*3", "*2/*6"],
  NOT_UGT1A1_GENOS: ["*1/*28", "*28/*28"],
  NEVER: "never",
  ANY: "any",
  YES: "yes",
  FILE: "file",
  FILES: "files",
  OTHER: "other",
  ACTIVE: "active",
  DEFAULT_DRUG_START: "2025-01-29",
  DEFAULT_DISEASE_START: "2025-01-29",
  ALL_DISEASES: "AllDiseases",
  DISEASES: "diseases",
  DISEASE: "disease",
  ADD: "add",
  REMOVE: "remove",
  PGX: "pgx",
  PGX_GENES: "pgxGenes",
  PGX_SELECTED_GENES: "pgxSelectedGenes",
  ALCOHOL: "alcohol",
  WEIGHT_HEIGHT: "weightHeight",
  DRUGS: "drugs",
  SUMMARY: "summary",
  END: "end",
  GENDER: "gender",
  FINISH: "finish",
  BACK: "back",
  NEXT: "next",
  PUT: "PUT",
  MEASUREMENT: "measurement",
  GENE_TEST: "genetest",
  INTERACTION: "interaction",
  INTERACTIONS: "interactions",
  DRUG: "drug",
  BMP: "bmp",
  CREATE: "create",
  TABLE: "table",
  GRAPH: "graph",
  HCP: "hcp",
  STUDY: "study",
  PLASMA: "plasma",
  STUDY_DIRECTOR: "studydirector",
  HCP_PRESCRIBER: "hcpprescriber",
  HOSPITAL: "hospital",
  SYMPTOMS: "symptoms",
  SYMPTOM: "symptom",
  MEASUREMENTS: "measurements",
  LAB_TESTS: "lab_tests",
  YEAR_OF_BIRTH: "year_of_birth",
  REG_AGE: "reg_age",
  STUDY_ARM: "study_arm",
  MED_PLAN: "medication_plan",
  LAST_LOGIN: "last_login",
  LAST_LOGIN_DAYS: "last_login_days",
  TOKEN: "token",
  ROLE: "role",
  NAME: "name",
  DELETE: "DELETE",
  YELLOW: "yellow",
  RED: "red",
  GREY: "grey",
  ORANGE: "orange",
  TRANSPARENT: "transparent",
  WHITE: "white",
  POST: "POST",
  GET: "GET",
  NONE: "none",
  TEST_DATE: "testDate",
  DATE_TIME: "dateTime",
  LAB_TEST_NAME: "labTestName",
  ROOT: "root",
  DAY: "day",
  CIRCLE: "circle",
  RECT: "rect",
  RESIZE: "resize",
  BOOLEAN: "boolean",
  API_IFRAME: "appIframe",
  BROWSE: "browse",
  NUMBER: "number",
  VALUE: "value",
  UNIT: "unit",
  PHENO: "PHENO",
  GENO: "GENO",
  TEXT: "text",
  HOURS: "hours",
  LAB: "lab",
  USERNAME: "username",
  PASSWORD: "password",
  APPLICATION_JSON: "application/json",
  POOR_521CC: "521CC",
  INTERMEDIATE_521TC: "521T",
  SAVE: "Save",
  CONFIRMED: "confirmed",
  DATE: "date",
  ETHNICITY_STUDY: "University Hospital of RWTH Aachen",
  ETHNICITY_STUDY2: "University Hospital of Patras",
  DEMO_HOSPITAL: "Demo-hospital",
  ACTIVE_SUBSTANCES: "activeSubstances",
  NOT_SPECIFIED: "not_specified",
  SEARCH: "search",
  FREE_TEXT: "freeText",
  NOT_AVAILABLE: "not_available",
  REGISTRATION_DATE: "registration_date",
  NUMBER_LOGINS: "number_logins",
  LAST_CHANGE: "last_change",
  DISEASES_LAST_CHANGE: "diseases_last_change",
  LAST_DISEASE_DAYS: "last_disease_days",
  LAST_MEASUREMENT_DAYS: "last_measurement_days",
  PGX_LAST_CHANGE: "pgx_last_change",
  MED_PLAN_LAST_CHANGE: "med_plan_last_change",
  SYMPTOMS_LAST_CHANGE: "symptoms_last_change",
  LAB_TESTS_LAST_CHANGE: "lab_tests_last_change",
  MEASUREMENTS_LAST_CHANGE: "measurements_last_change",
  NUMBER_DIFF_SYMPTOMS: "number_diff_complaints",
  NUMBER_OTHER_SYMPTOMS: "number_other_complaints",
  NUMBER_SYMPTOMS: "number_complaints",
  NUMBER_DDIS: "number_ddis",
  NUMBER_DGIS: "number_dgis",
  NUMBER_DDGIS: "number_ddgis",
  NUMBER_RISK_COMBINED: "risk_combined",
  NUMBER_RISK_RELATIVE: "risk_relative",
  NUMBER_DISEASES: "number_diseases",
  NUMBER_DRUGS_INITIAL: "number_drugs_initial",
  NUMBER_DRUGS: "number_drugs",
  NUMBER_NEW_ADDED_DRUGS: "number_added_drugs",
  NUMBER_DELETED_DRUGS: "number_deleted_drugs",
  NUMBER_MED_PLAN_CHANGES: "number_med_plan_changes",
  NUMBER_GENES: "number_genes",
  NUMBER_ACTIONABLE_GENES: "number_actionable genes",
  NUMBER_LAB_TESTS: "number_lab_tests",
  NUMBER_MEASUREMENTS: "number_measurements",
  NUMBER_PDMS: "number_pdms",
  DISABLE_PAT_LOGIN: true,
  INCREASED_RISK_LESS_10: "risk_relative_less_10",
  INCREASED_RISK_FROM_10_TO_20: "risk_relative_from_10_to_20",
  INCREASED_RISK_FROM_20_TO_30: "risk_relative_from_20_to_30",
  INCREASED_RISK_FROM_30_TO_40: "risk_relative_from_30_to_40",
  INCREASED_RISK_FROM_40_TO_50: "risk_relative_from_40_to_50",
  INCREASED_RISK_GREATER_50: "risk_relative_greater_50",
  COMBINED_RISK_LESS_10: "risk_combined_less_10",
  COMBINED_RISK_FROM_10_TO_20: "risk_combined_from_10_to_20",
  COMBINED_RISK_FROM_20_TO_30: "risk_combined_from_20_to_30",
  COMBINED_RISK_FROM_30_TO_40: "risk_combined_from_30_to_40",
  COMBINED_RISK_FROM_40_TO_50: "risk_combined_from_40_to_50",
  COMBINED_RISK_GREATER_50: "risk_combined_greater_50",
}

export const colors = [
  "#008000",
  "#008000",
  "#2ac719",
  "#FFA500",
  "#FF0000",
  "#c00006",
];